"use client";

import Image from "next/image";
import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { Drawer, DrawerContent, DrawerTrigger } from "../ui/drawer";
import { Button } from "../ui/button";
import { useMediaQuery } from "@/src/hooks/use-media-query";
import { DialogTitle } from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Heading } from "../common/Heading";
import { DialogDescription, DialogHeader } from "../ui/dialog";

const MenuBar = ({
  category,
  categoryLoading,
}: {
  category: any;
  categoryLoading: boolean;
}) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isDesktop) {
      setMobileMenuOpen(false);
    }
  }, [isDesktop]);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <Drawer
      direction="right"
      open={mobileMenuOpen}
      onOpenChange={(open) => setMobileMenuOpen(open)}
    >
      <DrawerTrigger asChild>
        <Image
          // className=" cursor-pointer"
          src={"/image/menu.png"}
          alt="Menu"
          width={28}
          height={28}
          priority={true}
          onContextMenu={(e) => e?.preventDefault()}
        />
      </DrawerTrigger>

      <DrawerContent
        // aria-describedby="menu-description"
        className="rounded-none"
      >
        <DialogHeader>
          <DialogTitle>
            <div className="flex w-full items-center justify-between px-6 py-4 shadow-lg">
              <Heading className="text-black">Shop by category</Heading>
              <Button
                variant={"ghost"}
                size="icon"
                onClick={toggleMenu}
                className="border-2"
              >
                <X size={32} />
              </Button>
            </div>
          </DialogTitle>
          <DialogDescription>
            {categoryLoading && (
              <div>
                {Array.from([1, 2, 3, 4, 5, 6, 7]).map((e, i) => (
                  <div
                    key={i}
                    className="mt-6 flex h-10 animate-pulse flex-col items-center justify-center rounded-lg bg-gradient-to-r from-gray-100 to-white p-4 shadow-md ring-1 ring-gray-100 transition-all duration-300 hover:scale-105 hover:ring-white"
                  >
                    <div className="w-full text-xs font-light tracking-wide"></div>
                  </div>
                ))}
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <Sidebar category={category} setIsOpen={setMobileMenuOpen} />
      </DrawerContent>
    </Drawer >
  );
};

export default MenuBar;
